import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private _logContext: string = "Local-storage.service";

  constructor(
    private storage: Storage,
    private _loggerService: LoggerService
  ) { }

  set(key: string, value: any) {
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "set()",
      "key: " + key
    );

    return this.storage.set(key, value).catch((err) => {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "set()",
        "Unable to save ''" + key + "'' to local storage. " + err.message
      );
    });
  }

  get(key: string) {
    return this.storage.get(key).catch((err) => {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "get()",
        "Unable to get " + key + " from local storage. " + err.message
      );
    });
  }

  remove(key: string) {
    return this.storage.remove(key).catch((err) => {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "remove()",
        "Unable to remve " + key + " from local storage. " + err.message
      );
    });
  }

  keysList() {
    return this.storage.keys();
  }

  removeAllBIStudio2Key() {
    //non cancello la lista plant in quanto deve essere sempre accessibile
    try {
      this.storage.remove(AppSettings.KEY_NOTIFICATION);
      this.storage.remove(AppSettings.KEY_CALENDAR);
      this.storage.remove(AppSettings.KEY_SCENARIOS);
      this.storage.remove(AppSettings.KEY_SCHEDULES);
      this.storage.remove(AppSettings.KEY_SUPERVISIONS);
      this.storage.remove(AppSettings.KEY_COSTUMERS_STAFF);
      this.storage.remove(AppSettings.KEY_ENVIRONMENT);
      this.storage.remove(AppSettings.KEY_TIMESLOT);
      this.storage.remove(AppSettings.KEY_ACCOUNTING_ENTITIES);
      this.storage.remove(AppSettings.KEY_REPORTHTML);
      this.storage.remove(AppSettings.KEY_CONTROLGROUP);
      this.storage.remove(AppSettings.KEY_WEEKLYPLANNING);

      this._loggerService.log(
        LogLevel.LOG_INFO,
        this._logContext,
        this._logContext,
        "removeAllBIStudio2Key()",
        "All BIGStudio2 keys removed from local storage"
      );
    } catch (exception) {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "removeAllBIStudio2Key()",
        "Error: " + exception.message
      );
    }
  }
}
